import React from "react";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import EmailIcon from "@material-ui/icons/Email";
import GithubIcon from "@material-ui/icons/GitHub";
import "../styles/Home.css";

function Home() {
  return (
    <div className="home">
      <div className="about">
        <h2> Hi, My Name is Julian</h2>
        <div className="prompt">
          <p>A software developer with a passion for learning and creating.</p>
          <a href="https://www.linkedin.com/in/julian-stennett-8386082a6/" target="_blank" rel="noopener noreferrer">
            <LinkedInIcon />
          </a>
          <a href="https://github.com/julianstennett" target="_blank" rel="noopener noreferrer">
            <GithubIcon />
          </a>
          <a href="mailto:stennju@gmail.com">
            <EmailIcon />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Home;